<div class="auth-callback-container">
  <div class="spinner-container">
    <div class="spinner"></div>
    <p>Completando autenticación...</p>
  </div>
</div>
